import { onClickHandler, getModuleSwitcherItemURL } from './onClickHandler';
import { IOverflowSetItemProps } from 'office-ui-fabric-react/lib/OverflowSet';
import { Module } from './Module';

export default function getModuleSwitcherItem(
    moduleType: Module,
    selectedModule: Module,
    displayName: string,
    icon: string,
    activeModuleAction?: (ev?: React.MouseEvent<unknown> | React.KeyboardEvent<HTMLElement>) => void
): IOverflowSetItemProps {
    return {
        key: displayName,
        iconProps: { iconName: icon },
        text: displayName,
        title: displayName,
        ariaLabel: displayName,
        name: displayName,
        workload: moduleType,
        href:
            selectedModule !== moduleType
                ? getModuleSwitcherItemURL(moduleType)
                : '' /* If module is selected, don't want to reboot whole page */,
        onClick: ev => {
            onClickHandler(moduleType, selectedModule, activeModuleAction, true);
        },
    };
}
